export const migrateToV2 = (entities)=>{
    return entities;
};

//# sourceMappingURL=v2.js.map